import { TagProps } from "@chakra-ui/react";
import { errorStyles, grayStyles, greenStyles, orangeStyles } from "components/Tag/Status/styles";
import BaseActionStatus from "components/Tag/Status/BaseActionStatus";
import { HorizontalGreyBlackField } from "components/DataDisplay/GreyBlackField";
import { longAttributeStyles } from "components/DataDisplay/styles";

type CheckpointStatus = "pending" | "complete" | "partial" | "behind" | "skipped" | "removed" | "failed";

interface CheckpointStatusProps extends TagProps {
  status: CheckpointStatus;
}

function checkpointStatusStyles(status: CheckpointStatus) {
  switch (status) {
    case "complete":
      return greenStyles;
    case "partial":
      return orangeStyles;
    case "behind":
    case "failed":
      return errorStyles;
    case "skipped":
    case "removed":
      return grayStyles;
    case "pending":
      return orangeStyles;
    default:
      return {};
  }
}

const STATUS_LABELS: Record<CheckpointStatus, string> = {
  pending: "Not Evaluated",
  complete: "Good to Go!",
  partial: "Needs a Nudge",
  behind: "Behind Schedule",
  skipped: "Skipped",
  removed: "Removed",
  failed: "Failed",
};

export function ShortCheckpointStatus({ status, ...rest }: CheckpointStatusProps) {
  if (status === "pending") return null;
  return (
    <BaseActionStatus {...checkpointStatusStyles(status)} {...rest}>
      {STATUS_LABELS[status] || status}
    </BaseActionStatus>
  );
}

export function FullCheckpointStatus({ status, ...rest }: CheckpointStatusProps) {
  return (
    <BaseActionStatus {...checkpointStatusStyles(status)} {...rest}>
      {STATUS_LABELS[status] || status}
    </BaseActionStatus>
  );
}

export function ShowCheckpointStatus({ status, ...rest }: CheckpointStatusProps) {
  return (
    <HorizontalGreyBlackField label="Status" labelContainerProps={longAttributeStyles.labelContainerProps}>
      <FullCheckpointStatus status={status} {...rest} />
    </HorizontalGreyBlackField>
  );
}
